export default {
  distanceToStart: 'Time Until Event Starts',
  distanceToEnd: 'Time Until Event Ends',
  ended: 'Event Ended',
  moonPhase: {
    introduction: 'The moon phases will progress based on the total Rainbow Diamonds top-up progress of all players throughout the event. Once the full moon is reached, all players who participate in this event will receive the limited Full Moon reward [Title - Mid-Autumn Full Moon].',
    new_moon: 'New Moon',
    crescent_moon: 'Waxing Crescent',
    first_quarter: 'First Quarter',
    gibbous_moon: 'Waxing Gibbous',
    full_moon: 'Full Moon',
  },
  rewards: {
    clickHere: 'Click Here',
    introduceText1: 'Go to the Official Top-Up Center [{clickHere}]. Accumulate 200/500/1,000/3,000/5,000/8,000 Rainbow Diamonds in Top-Ups to claim Milestone Rewards.',
    introduceText2: 'Event Period: Sep 25, 2026, 01:00 – Oct 5, 2026, 00:59 (GMT+8).',
    introduceText3: 'Rewards must be claimed by Oct 5, 2026, 00:59 (GMT+8).',
  }
}